import React from 'react';
import { Route, Switch } from 'react-router-dom';

import List from './List';
import Session from './Session';
import './style.scss';

const ImportFromSazd = () => <div className="import-from-sazd">
	<div className="hdr">Импорт из САЗД в EPZ</div>
	<Switch>
		<Route path="/admin/plenarysessions/sazd" exact component={List} />
		<Route path="/admin/plenarysessions/sazd/:id" component={Session} />
	</Switch>
</div>;

export default ImportFromSazd;
